import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class AppFooterResetService {
  private footerMessageSource  = new Subject<void>();
  changebanner$ = this.footerMessageSource.asObservable();

  updateBanneronFooter(): void {
    this.footerMessageSource.next();
  }
}
